import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {LessonData} from "../../../types/lessosnSchema";





interface LessonState {
    items: LessonData[];
    success: boolean;
    isLoading: boolean;
    error: string | null;
    errors: {
        [key: string]: string[];
    };
}

const initialState: LessonState = {
    items: [],
    success: false,
    isLoading: true,
    error: null,
    errors: {},
};


const lessonsSlice = createSlice({
    name: "lessons",
    initialState,
    reducers: {
        setLessons: (state, action) => {
            const { items } = action.payload;
            state.items = items;
            state.isLoading = false;
            state.error = null;
            state.success = false;
        },
        setLoading: (state, action: PayloadAction<{ isLoading:boolean }>) => {
            state.isLoading = action.payload.isLoading;
        },
        setError: (
            state,
            action: PayloadAction<{
                success: boolean;
                error: string;
                errors: Record<string, string[]>;
            }>
        ) => {
            state.error = action.payload.error;
            state.errors = action.payload.errors;
            state.success = false;
        },
        setSuccess: (state, action: PayloadAction<{ success:boolean }>) => {
            state.success = action.payload.success;
        },
        setErrors: (state, action: PayloadAction<{ success: boolean; error: string; errors: { [key: string]: string[] } }>) => {
            state.error = action.payload.error;
            state.errors = action.payload.errors;
            state.success = false;
        },
        clearError: (state, action: PayloadAction<string>) => {
            // Удаляем ошибку для указанного поля
            delete state.errors[action.payload];
        },
        clearAllErrors: (state) => {
            // Очищаем все ошибки
            state.errors = {};
        },
    },
});

export const {
    setLessons,
    setLoading,
    setError,
    setSuccess,
    setErrors,
    clearAllErrors,
    clearError
} = lessonsSlice.actions;

export const lessonsReducer = lessonsSlice.reducer;
